var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_593_1102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 24.7292V28.375C60 29.1785 59.3467 29.8333 58.5417 29.8333H54.8958C54.4933 29.8333 54.1667 29.5067 54.1667 29.1042C54.1667 28.7017 54.4933 28.375 54.8958 28.375H57.0717C55.7081 26.5565 53.5775 25.4583 51.25 25.4583C47.451 25.4583 44.3288 28.3079 43.989 32.0865C43.9554 32.4656 43.636 32.75 43.2627 32.75C43.2408 32.75 43.219 32.75 43.1971 32.7471C42.796 32.7106 42.5 32.3563 42.5365 31.9552C42.9448 27.4198 46.6912 24 51.2515 24C54.2265 24 56.9317 25.4904 58.5431 27.9346V24.7292C58.5431 24.3267 58.8698 24 59.2723 24C59.6748 24 60 24.3267 60 24.7292ZM49.7917 45.1458V53.2702C49.7917 56.4829 44.3477 59 37.3958 59C30.444 59 25 56.4829 25 53.2702V30.5625C25 26.8831 30.444 24 37.3958 24C38.9592 24 40.4788 24.1473 41.9152 24.4375C42.3104 24.5177 42.5656 24.9027 42.4854 25.2965C42.4154 25.6421 42.1106 25.8812 41.7708 25.8812C41.7227 25.8812 41.6746 25.8769 41.625 25.8667C40.2833 25.594 38.86 25.4569 37.3944 25.4569C31.4677 25.4583 26.4583 27.796 26.4583 30.5625C26.4583 33.329 31.4677 35.6667 37.3958 35.6667C37.8756 35.6667 38.3467 35.6521 38.8104 35.6229C39.2173 35.6054 39.5585 35.9044 39.5819 36.3069C39.6067 36.7079 39.3004 37.055 38.8979 37.0783C38.4065 37.109 37.9048 37.125 37.3958 37.125C32.6023 37.125 28.5277 35.7542 26.4583 33.6965V38.2421C26.4583 40.52 30.8538 42.9569 37.3958 42.9569C38.351 42.9569 39.3033 42.9015 40.2265 42.7906C40.6246 42.7381 40.9892 43.0298 41.0373 43.4279C41.0854 43.8275 40.7996 44.1906 40.3985 44.2388C39.4185 44.3554 38.4079 44.4152 37.3958 44.4152C32.6023 44.4152 28.5277 43.126 26.4583 41.1908V45.5338C26.4583 47.8117 30.8538 50.2485 37.3958 50.2485C43.9379 50.2485 48.3333 47.8102 48.3333 45.5338V45.1444C48.3333 44.7419 48.66 44.4152 49.0625 44.4152C49.465 44.4152 49.7917 44.7419 49.7917 45.1444V45.1458ZM48.3333 48.484C46.264 50.4192 42.1894 51.7083 37.3958 51.7083C32.6023 51.7083 28.5277 50.4192 26.4583 48.484V53.2717C26.4583 55.2915 30.95 57.5431 37.3958 57.5431C43.8417 57.5431 48.3333 55.2915 48.3333 53.2717V48.484ZM59.3029 32.7529C58.899 32.7092 58.546 33.011 58.511 33.4135C58.1713 37.1921 55.049 40.0417 51.25 40.0417C48.9225 40.0417 46.7919 38.9435 45.4283 37.125H47.6042C48.0067 37.125 48.3333 36.7983 48.3333 36.3958C48.3333 35.9933 48.0067 35.6667 47.6042 35.6667H43.9583C43.1548 35.6667 42.5 36.3215 42.5 37.125V40.7708C42.5 41.1733 42.8267 41.5 43.2292 41.5C43.6317 41.5 43.9583 41.1733 43.9583 40.7708V37.5654C45.5698 40.0081 48.275 41.5 51.25 41.5C55.8088 41.5 59.5552 38.0802 59.965 33.5448C60 33.1438 59.7054 32.7894 59.3044 32.7529H59.3029Z",
    fill: "#00715D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_593_1102",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_593_1102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_593_1102",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataicon);
export default __webpack_public_path__ + "static/media/dataicon.f6c8b208294c78a3f36d72eaf1e7d436.svg";
export { ForwardRef as ReactComponent };